import { render } from "./scene2.vue?vue&type=template&id=0a19d7b0&scoped=true&bindings={\"isActive2\":\"data\",\"change2\":\"options\",\"closeModal\":\"options\"}"
import script from "./scene2.vue?vue&type=script&lang=js"
export * from "./scene2.vue?vue&type=script&lang=js"

import "./scene2.vue?vue&type=style&index=0&id=0a19d7b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a19d7b0"

export default script